import React, { Component } from 'react';
import ComTable from '../ComTable';

class Education extends Component {
    state = {
        config: [],
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '毕业时间',
            en: 'Time',
            key: 'graduationTimeShow',
        }, {
            zh: '学校名称',
            en: 'University',
            key: 'schoolName',
            width: 400,
        }, {
            zh: '专业',
            en: 'Major',
            key: 'specialTypeShow',
            width: 200,
        }, {
            zh: '学历',
            en: 'Degree',
            key: 'academicQualification',
        }];
        this.setState({ config });
    }

    getDataSource = () => {
        const { data, isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                schoolNameChinese,
                schoolNameEnglish,
                specialTypeShow,
                specialTypeShowEnglish,
                academicQualification,
                academicQualificationEnglish,
            } = item;
            return {
                index: index + 1,
                ...item,
                schoolName: isChinese ? schoolNameChinese : schoolNameEnglish,
                specialTypeShow: isChinese ? specialTypeShow : specialTypeShowEnglish,
                academicQualification: isChinese ? academicQualification : academicQualificationEnglish,
            }
        });
        return dataSource;
    }

    render() {
        const { isChinese } = this.props;
        const { config, loading } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        return (
            <ComTable
                config={result}
                loading={loading}
                pagination={false}
                getDataSource={this.getDataSource}
            />
        );
    }
}

export default Education;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/Education.js